var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"name":"snackbars"}},[_c('SnackbarQueue',{attrs:{"items":_vm.items,"next-button-count-text":_vm.$t('misc.more'),"nextButtonColor":_vm.$store.state.snackbar.color,"nextButtonText":_vm.$t('misc.next'),"bottom":"","right":"","multiLine":""},on:{"remove":_vm.removeItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }